<template>
  <div class="statistical-box">
    <vs-tooltip :text="tooltipText ? tooltipText : null">
      <div class="stat-icon">
        <feather-icon :icon="icon" svgClasses="w-6"/>
      </div>
      <div class="stat-number">{{ value }}</div>
      <div class="stat-label" v-if="label">{{ label }}</div>
    </vs-tooltip>
  </div>
</template>
<script>
export default {
  name: "Stat-Box",
  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    tooltipText: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      default: 'InfoIcon',
    }
  }
};
</script>
<style lang="scss">

.statistical-box {
  color: black;
  border: 1px solid black;
  padding: 10px;
  text-align: center;
  width: 120px;
  border-radius: 5px;

}
</style>
